"use client";

import { PostSlider } from "@/components/blog/PostSlider";
import { articles } from "@/data/article";
import { Article as ArticleType } from "@/types/article.type";
import Link from "next/link";
import { useInView } from "react-intersection-observer";

export const Article = ({ articles }: { articles: ArticleType[] }) => {
  const { ref: circleRef, inView: circleInView } = useInView({
    triggerOnce: true,
  });
  const { ref: squareRef, inView: squareInView } = useInView({
    triggerOnce: true,
  });

  const filteredArticles = articles
    .filter((article) => article.category.toLowerCase() !== "community action")
    .sort((a, b) => {
      const dateA = a.createdAt ? new Date(a.createdAt).getTime() : 0;
      const dateB = b.createdAt ? new Date(b.createdAt).getTime() : 0;
      return dateB - dateA;
    });

  return (
    <div
      className="relative flex flex-col w-full h-fit items-center justify-start"
      id="blog"
    >
      <svg
        ref={circleRef}
        className={`w-[200px] h-[100px] absolute bottom-0 left-[5%] ${circleInView ? "translate-y-0" : "translate-y-full"} transition-all duration-[1.5s] ease-in-out -z-50`}
        viewBox="0 0 200 100"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <circle opacity="0.35" cx="100" cy="100" r="100" fill="#FFBD58" />
      </svg>

      <svg
        ref={squareRef}
        className="w-[80px] sm:w-[116px] h-[250px] sm:h-[416px] absolute right-[5%] top-[-10%] md:top-[-25%] -z-50"
        viewBox="0 0 116 416"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <rect
          className="transition-all duration-[2.5s] ease-out"
          opacity="0.35"
          x="8"
          y="8"
          width="100"
          height="400"
          rx="50"
          stroke="#FFBD58"
          strokeWidth="15"
          strokeDasharray={1000}
          strokeDashoffset={squareInView ? 0 : 1000}
        />
      </svg>

      {/* Blog Article Content */}
      <div className="flex flex-col gap-12 md:gap-16 items-center justify-center w-full px-6 py-12 lg:px-0 lg:pt-14 lg:pb-28">
        {/* Heading */}
        <h2 className="text-natura-primary text-3xl md:text-4xl lg:text-5xl text-center font-serifText">
          Artikel Terbaru Kami
        </h2>

        {/* Post slider */}
        <div className="flex flex-col items-center justify-center gap-8 md:gap-12 ">
          <PostSlider data={filteredArticles} />
          <Link
            href={"/article"}
            className="flex items-center justify-center px-6 py-3 rounded-full bg-natura-primary hover:bg-natura-hover active:bg-natura-pressed transition-all duration-150 w-fit font-nunito text-white font-normal cursor-pointer text-xs md:text-base leading-normal"
          >
            Lihat Artikel Lainnya
          </Link>
        </div>
      </div>
    </div>
  );
};
